const linkUtils = {
  fullLinkUrl: function (path) {
    let port = window.location.port ? ":" + window.location.port : ""
    return window.location.protocol + "//" + window.location.hostname + port + path;
  },

  accountMoneyClaimsDetailsPath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-money-claims-details',
      params: {id: details.account_id, money_claim_id: details.money_claim_id}
    });

    return props.href
  },
  accountTopUpsPath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-top-ups',
      params: {id: details.account_id}
    });

    return props.href
  },
  accountTopUpPath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-top-ups-details',
      params: {id: details.account_id, top_up_id: details.top_up_id}
    });

    return props.href
  },
  accountTicketPath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-journey-details',
      params: {id: details.account_id, journey_id: details.id}
    });

    return props.href
  },
  accountProfilePath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-journeys',
      params: {id: details.account_id}
    });
    return props.href
  },
  accountProfileAssociationsPath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-associations',
      params: {id: details.account_id}
    });
    return props.href
  },
  accountJourneysPath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-journeys',
      params: {id: details.account_id}
    });
    return props.href
  },
  accountEmailsPath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-emails',
      params: {id: details.account_id}
    });
    return props.href
  },
  accountAuditLogsPath: function ($router, details) {
    let props = $router.resolve({
      name: 'account-audit-logs',
      params: {id: details.account_id}
    });
    return props.href
  },
  fareGroupPath: function ($router, details) {
    let props = $router.resolve({
      name: 'fare-group',
      params: {id: details.fare_group_id}
    });
    return props.href
  },
  inspectorTeamPath: function ($router, details) {
    let props = $router.resolve({
      name: 'inspector_team',
      params: {id: details.inspector_team_id}
    });
    return props.href
  },
  systemAccountPath: function ($router, details) {
    let props = $router.resolve({
      name: 'system_account',
      params: {id: details.system_account_id}
    });
    return props.href
  },
  distributorReportPath: function ($router, details) {
    let props = $router.resolve({
      name: 'distributor_report',
      params: {id: details.distributor_id},
    });
    return props.href
  },
  distributorPath: function ($router, details) {
    let props = $router.resolve({
      name: 'distributor',
      params: {id: details.id},
    });
    return props.href
  },
  municipalityPath: function ($router, details) {
    let props = $router.resolve({
      name: 'municipality',
      params: {id: details.id},
    });
    return props.href
  },
  operatorPath: function ($router, details) {
    let props = $router.resolve({
      name: 'operator',
      params: {id: details.id},
    });
    return props.href
  }
}
export default linkUtils
